import { useEffect } from 'react';

let locks = 0;
let saved = null;

// Ref-counted so stacked popups don't unlock the page while one is still open.
export function useLockBodyScroll(isOpen) {
    useEffect(() => {
        if (!isOpen) return undefined;
        const html = document.documentElement;
        const body = document.body;
        if (locks === 0) {
            const scrollbarWidth = window.innerWidth - html.clientWidth;
            saved = { body: body.style.overflow, html: html.style.overflow, pad: body.style.paddingRight };
            body.style.overflow = 'hidden';
            html.style.overflow = 'hidden';
            if (scrollbarWidth > 0) body.style.paddingRight = `${scrollbarWidth}px`;
        }
        locks += 1;
        return () => {
            locks -= 1;
            if (locks === 0 && saved) {
                body.style.overflow = saved.body;
                html.style.overflow = saved.html;
                body.style.paddingRight = saved.pad;
                saved = null;
            }
        };
    }, [isOpen]);
}
